module.exports = __webpack_public_path__ + "static/media/Expand Menu.04d0482d.svg";